<template>
    <ul class="mx-auto mt-12 text-pink-900 flex items-end justify-center">
        <li aria-disabled="true" aria-label="« Previous">
            <span class="bg-white px-3 py-2 rounded-l-md" aria-hidden="true">‹</span>
        </li>
        <li><a class="bg-pink bg-pink-800 text-white border-white border px-3 py-[7px]">1</a></li>
        <li><a class="bg-white px-3 py-2">2</a></li>
        <li><a class="bg-white px-3 py-2">3</a></li>
        <li aria-disabled="true" aria-label="Next »">
            <span class="bg-white px-3 py-2 rounded-r-md" aria-hidden="true">›</span>
        </li>
        
    </ul>
</template>